import React from "react";
import Hero from "../gsa/Hero";
import TheGreatSage from "../gsa/TheGreatSage";
import FinalSpiritual from "../gsa/FinalSpiritual";
import SahajYogaCard from "../common/SahajYogaCard";
import HeaderOnly from "../common/HeaderOnly";
import Footer from "../common/Footer";
const GSA = () => {
  return (
    <>
      <HeaderOnly />
      <TheGreatSage />
      <FinalSpiritual />
      <SahajYogaCard />
      <Footer />
    </>
  );
};

export default GSA;
